/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import { array, arrayOf, bool, func, shape, string, oneOf } from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { map, pathOr, reduce, includes, path, reject } from 'ramda';

import config from '../../config';
import routeConfiguration from '../../routeConfiguration';
import { LISTING_STATE_PENDING_APPROVAL, LISTING_STATE_CLOSED, propTypes } from '../../util/types';
import { types as sdkTypes } from '../../util/sdkLoader';
import {
  LISTING_PAGE_PENDING_APPROVAL_VARIANT,
  LISTING_PAGE_PARAM_TYPE_EDIT,
  createSlug,
} from '../../util/urlHelpers';
import { formatMoney } from '../../util/currency';
import { createResourceLocatorString, findRouteByRouteName } from '../../util/routes';
import {
  ensureListing,
  ensureOwnListing,
  ensureUser,
  userDisplayNameAsString,
} from '../../util/data';
import { richText } from '../../util/richText';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { manageDisableScrolling, isScrollingDisabled } from '../../ducks/UI.duck';
import { initializeCardPaymentData } from '../../ducks/stripe.duck.js';
import {
  Page,
  NamedLink,
  NamedRedirect,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  BookingPanel,
  CriteoProduct,
  Modal,
  ProfileCompletionModal,
} from '../../components';
import { TopbarContainer, NotFoundPage } from '../../containers';
import {
  sendEnquiry,
  loadData,
  setInitialValues,
} from './ListingPage.duck';
import SectionTitle from './SectionTitle';
import SectionImages from './SectionImages';
import SectionHeading from './SectionHeading';
import SectionDescription from './SectionDescription';
import SectionFeaturesMaybe from './SectionFeaturesMaybe';
import SectionReviews from './SectionReviews';
import SectionHostMaybe from './SectionHostMaybe';
import SectionRulesMaybe from './SectionRulesMaybe';
import SectionActions from './SectionActions';
import SectionSimilarListings from './SectionSimilarListings';
import {
  utcTimeZone,
  followingDay,
  getDateWithTimezone,
  getBookingDates,
} from '../../util/dates';
import { addTransactionTracking } from '../../util/transactionTrackerHelpers';
import { maskContactDetails } from '../../util/contactDetails';
import css from './ListingPage.css';
import { EnquiryForm } from '../../forms';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import SectionSessionTimes from '../../components/SectionSessionTimes';

const MIN_LENGTH_FOR_LONG_WORDS_IN_TITLE = 16;

const { UUID } = sdkTypes;

const priceData = (price, intl) => {
  if (price && price.currency === config.currency) {
    const formattedPrice = formatMoney(intl, price);
    return { formattedPrice, priceTitle: formattedPrice };
  } else if (price) {
    return {
      formattedPrice: `(${price.currency})`,
      priceTitle: `Unsupported currency (${price.currency})`,
    };
  }
  return {};
};

export class ListingPageComponent extends Component {
  constructor(props) {
    super(props);
    const { enquiryModalOpenForListingId, params } = props;
    this.state = {
      pageClassNames: [],
      imageCarouselOpen: false,
      enquiryModalOpen: enquiryModalOpenForListingId === params.id,
      bookingDataValues: {},
      isProfileCompletionModalOpen: false,
      shareModalOpen: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.onContactUser = this.onContactUser.bind(this);
    this.onSubmitEnquiry = this.onSubmitEnquiry.bind(this);
  }

  handleToogleProfileCompletionModal = () => {
    this.setState(prevState => ({
      isProfileCompletionModalOpen: !prevState.isProfileCompletionModalOpen
    }));
  };

  handleSubmit() {
    const {
      history,
      getListing,
      params,
      callSetInitialValues,
      onInitializeCardPaymentData,
    } = this.props;
    const listingId = new UUID(params.id);
    const listing = getListing(listingId);

    const { bookingDate, ...bookingData } = this.state.bookingDataValues;
    const startDate =  bookingDate.date;
    const { start, end } = getBookingDates(startDate, bookingData.isBookingFullDay);
    const initialValues = {
      listing,
      bookingData,
      bookingDates: {
        bookingStart: start,
        bookingEnd: end,
      },
      confirmPaymentError: null,
    };

    const saveToSessionStorage = !this.props.currentUser;

    const routes = routeConfiguration();
    // Customize checkout page state with current listing and selected bookingDates
    const { setInitialValues } = findRouteByRouteName('CheckoutPage', routes);

    callSetInitialValues(setInitialValues, initialValues, saveToSessionStorage);

    // Clear previous Stripe errors from store if there is any
    onInitializeCardPaymentData();

    // Redirect to CheckoutPage
    history.push(
      createResourceLocatorString(
        'CheckoutPage',
        routes,
        { id: listing.id.uuid, slug: createSlug(listing.attributes.title) },
        {}
      )
    );
  }

  handleOkBookingModal = () => {
    const { history, getListing, params, callSetInitialValues } = this.props;
    const listingId = new UUID(params.id);
    const listing = getListing(listingId);
    const { bookingDate, ...bookingData } = this.state.bookingDataValues;
    const startDate =  bookingDate.date;
    const endDate =  followingDay(startDate);
    const initialValues = {
      listing,
      bookingData,
      bookingDates: {
        bookingStart: startDate,
        bookingEnd: endDate,
      },
    };
    const saveToSessionStorage = !this.props.currentUser;
    const routes = routeConfiguration();
    const { setInitialValues } = findRouteByRouteName('CheckoutPage', routes);
    callSetInitialValues(setInitialValues, initialValues, saveToSessionStorage);
    const redirectOnValidate = createResourceLocatorString(
      'CheckoutPage',
      routes,
      { id: listing.id.uuid, slug: createSlug(listing.attributes.title) },
      {},
    );

    // Redirect to ProfileSettingsPage
    history.push(
      createResourceLocatorString(
        'ProfileSettingsPage',
        routes,
        {},
        { redirectOnValidate },
      )
    );
  };

  handleOpenBookingModal = async (values) => {
    const currentUserData =
      pathOr({}, ['currentUser', 'attributes', 'profile', 'protectedData'], this.props);
    const dataRequired = ['phoneNumber'];
    const hasRequiredData = reduce((acc, curr) => !!currentUserData[curr], false, dataRequired);
    await this.setState({
      bookingDataValues: values,
    });
    if (hasRequiredData) {
      this.handleSubmit();
      return;
    }

    this.handleToogleProfileCompletionModal();
  };

  onContactUser= async (bookingDate, numberOfAdults, numberOfChildren, numberOfInfants, isBookingFullDay) => {
    const { currentUser, history, callSetInitialValues, params, location } = this.props;
    await this.setState({
      bookingDataValues: {
        bookingDate,
        numberOfAdults,
        numberOfChildren,
        numberOfInfants,
        isBookingFullDay,
      },
    });

    if (!currentUser) {
      const state = { from: `${location.pathname}${location.search}${location.hash}` };

      // We need to log in before showing the modal, but first we need to ensure
      // that modal does open when user is redirected back to this listingpage
      callSetInitialValues(setInitialValues, { enquiryModalOpenForListingId: params.id });

      // signup and return back to listingPage.
      history.push(createResourceLocatorString('SignupPage', routeConfiguration(), {}, {}), state);
    } else {
      this.setState({ enquiryModalOpen: true });
    }
  };

  handleTrackingTransaction = (transactionId, currentUser, numberOfParticipants, bookingDate, providerId) => {
    const transactionTracking = {
      transactionId,
      customerId: path(['id', 'uuid'], currentUser),
      providerId,
      bookingDate: bookingDate,
      followedBy: '',
      numberOfParticipants,
    };
    addTransactionTracking({ ...transactionTracking, state: 'message' });
  };

  handleSubmitEnquiryWithPartialData = (values) => {
    const { message } = values;
    const { bookingDataValues } = this.state;
    const { bookingDate, numberOfAdults = 0, numberOfChildren = 0, numberOfInfants = 0, isBookingFullDay } = bookingDataValues;
    this.onSubmitEnquiry({message, bookingDate, numberOfAdults, numberOfChildren, numberOfInfants, isBookingFullDay});
  };

  onSubmitEnquiry(values) {
    const { intl, history, params, onSendEnquiry, isPendingApprovalVariant, getOwnListing, getListing, currentUser, searchParams } = this.props;
    const { message, bookingDate, numberOfAdults = 0, numberOfChildren = 0, numberOfInfants = 0, isBookingFullDay } = values;
    const routes = routeConfiguration();
    const listingId = new UUID(params.id);
    const currentListing = isPendingApprovalVariant
      ? ensureOwnListing(getOwnListing(listingId))
      : ensureListing(getListing(listingId));
    const providerId = path(['author', 'id', 'uuid'], currentListing);
    const dateWithTz = getDateWithTimezone(bookingDate.date, utcTimeZone);
    const messageFormatted = message.trim();
    const participants = {
      adults: numberOfAdults,
      children: numberOfChildren,
      infants: numberOfInfants,
      total: parseInt(numberOfAdults) + parseInt(numberOfChildren),
    };

    onSendEnquiry(listingId, bookingDate.date, dateWithTz.toISOString(), isBookingFullDay, participants, maskContactDetails(messageFormatted.trim(), intl), searchParams)
      .then(txId => {
        const { uuid } = txId;
        this.setState({ enquiryModalOpen: false });
        this.handleTrackingTransaction(uuid, currentUser, participants, bookingDate.date, providerId);

        // Redirect to OrderDetailsPage
        history.push(
          createResourceLocatorString('OrderDetailsPage', routes, { id: txId.uuid }, {})
        );
      })
      .catch(() => {
        // Ignore, error handling in duck file
      });
  }

  render() {
    const {
      unitType,
      isAuthenticated,
      currentUser,
      getListing,
      getOwnListing,
      intl,
      onManageDisableScrolling,
      params: rawParams,
      location,
      scrollingDisabled,
      showListingError,
      reviews,
      fetchReviewsError,
      sendEnquiryInProgress,
      sendEnquiryError,
      timeSlots,
      fetchTimeSlotsError,
      amenitiesConfig,
      providerPresentConfig,
      securityConfig,
      onUpdateCurrentProfile,
      myFavorites = [],
      isInMyFavorites,
      searchParams,
      history,
      similarListings,
      searchInProgress,
      searchListingsError,
    } = this.props;

    const listingId = new UUID(rawParams.id);
    const isPendingApprovalVariant = rawParams.variant === LISTING_PAGE_PENDING_APPROVAL_VARIANT;
    const currentListing =
      isPendingApprovalVariant
        ? ensureOwnListing(getOwnListing(listingId))
        : ensureListing(getListing(listingId));

    const listingSlug = rawParams.slug || createSlug(currentListing.attributes.title || '');
    const params = { slug: listingSlug, ...rawParams };

    const listingType = LISTING_PAGE_PARAM_TYPE_EDIT;
    const listingTab = 'description';

    const isApproved =
      currentListing.id && currentListing.attributes.state !== LISTING_STATE_PENDING_APPROVAL;

    const pendingIsApproved = isPendingApprovalVariant && isApproved;

    // If a /pending-approval URL is shared, the UI requires
    // authentication and attempts to fetch the listing from own
    // listings. This will fail with 403 Forbidden if the author is
    // another user. We use this information to try to fetch the
    // public listing.
    const pendingOtherUsersListing =
      isPendingApprovalVariant &&
      showListingError &&
      showListingError.status === 403;
    const shouldShowPublicListingPage = pendingIsApproved || pendingOtherUsersListing;

    if (shouldShowPublicListingPage) {
      return <NamedRedirect name="ListingPage" params={params} search={location.search} />;
    }

    const {
      description = '',
      geolocation = null,
      price = null,
      title = '',
      publicData,
    } = currentListing.attributes;

    const {
      maxCapacityToGuest,
      minCapacityToGuest,
      enfantsBienvenue: suitableForChildren,
      isHostedBySuperHost,
    } = publicData;

    const minCapacity = minCapacityToGuest && !(isNaN(minCapacityToGuest)) ? minCapacityToGuest : 1;

    const richTitle = (
      <span>
        {richText(title, {
          longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS_IN_TITLE,
          longWordClass: css.longWord,
        })}
      </span>
    );

    const topbar = <TopbarContainer currentPage='ListingPage' />;

    if (showListingError && showListingError.status === 404) {
      // 404 listing not found

      return <NotFoundPage />;
    } else if (showListingError) {
      // Other error in fetching listing

      const errorTitle = intl.formatMessage({
        id: 'ListingPage.errorLoadingListingTitle',
      });

      return (
        <Page title={errorTitle} scrollingDisabled={scrollingDisabled}>
          <LayoutSingleColumn className={css.pageRoot}>
            <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
            <LayoutWrapperMain>
              <p className={css.errorText}>
                <FormattedMessage id="ListingPage.errorLoadingListingMessage" />
              </p>
            </LayoutWrapperMain>
            <LayoutWrapperFooter>
              <Footer />
            </LayoutWrapperFooter>
          </LayoutSingleColumn>
        </Page>
      );
    } else if (!currentListing.id) {
      // Still loading the listing

      const loadingTitle = intl.formatMessage({
        id: 'ListingPage.loadingListingTitle',
      });

      return (
        <Page title={loadingTitle} scrollingDisabled={scrollingDisabled}>
          <LayoutSingleColumn className={css.pageRoot}>
            <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
            <LayoutWrapperMain>
              <p className={css.loadingText}>
                <FormattedMessage id="ListingPage.loadingListingMessage" />
              </p>
            </LayoutWrapperMain>
            <LayoutWrapperFooter>
              <Footer />
            </LayoutWrapperFooter>
          </LayoutSingleColumn>
        </Page>
      );
    }

    const handleViewPhotosClick = e => {
      // Stop event from bubbling up to prevent image click handler
      // trying to open the carousel as well.
      e.stopPropagation();
      this.setState({
        imageCarouselOpen: true,
      });
    };
    const handleShareClick = e => {
      e.stopPropagation();
      this.setState({
        shareModalOpen: true,
      });
    };
    const handleFavoritesClick = e => {
      const routes = routeConfiguration();
      if (!isAuthenticated) {
        return history.push(createResourceLocatorString('LoginPage', routes, {}));
      }
      e.stopPropagation();
      const myNewFavorites = isInMyFavorites ? reject(fav => fav ===  listingId.uuid, myFavorites) : [listingId.uuid, ...myFavorites];
      const profileUpdated = {
        protectedData: {
          myFavorites: myNewFavorites,
        }
      };
      onUpdateCurrentProfile(profileUpdated);
    };
    const authorAvailable = currentListing && currentListing.author;
    const userAndListingAuthorAvailable = !!(currentUser && authorAvailable);
    const isOwnListing =
      userAndListingAuthorAvailable && currentListing.author.id.uuid === currentUser.id.uuid;
    const showContactUser = authorAvailable && (!currentUser || (currentUser && !isOwnListing));

    const currentAuthor = authorAvailable ? currentListing.author : null;
    const ensuredAuthor = ensureUser(currentAuthor);

    // When user is banned or deleted the listing is also deleted.
    // Because listing can be never showed with banned or deleted user we don't have to provide
    // banned or deleted display names for the function
    const authorDisplayName = userDisplayNameAsString(ensuredAuthor, '');

    const { formattedPrice, priceTitle } = priceData(price, intl);

    const handleBookingSubmit = values => {
      const isCurrentlyClosed = currentListing.attributes.state === LISTING_STATE_CLOSED;
      if (isOwnListing || isCurrentlyClosed) {
        window.scrollTo(0, 0);
      } else {
        this.handleOpenBookingModal(values);
      }
    };

    const listingImages = (listing, variantName) =>
      (listing.images || [])
        .map(image => {
          const variants = image.attributes.variants;
          const variant = variants ? variants[variantName] : null;

          // deprecated
          // for backwards combatility only
          const sizes = image.attributes.sizes;
          const size = sizes ? sizes.find(i => i.name === variantName) : null;

          return variant || size;
        })
        .filter(variant => variant != null);

    const facebookImages = listingImages(currentListing, 'facebook');
    const twitterImages = listingImages(currentListing, 'twitter');
    const schemaImages = JSON.stringify(facebookImages.map(img => img.url));
    const siteTitle = config.siteTitle;
    const schemaTitle = intl.formatMessage(
      { id: 'ListingPage.schemaTitle' },
      { title, price: formattedPrice, siteTitle }
    );

    const hostLink = (
      <NamedLink
        className={css.authorNameLink}
        name="ListingPage"
        params={params}
        to={{ hash: '#host' }}
      >
        {authorDisplayName}
      </NamedLink>
    );

    const rating = pathOr(null, ['attributes', 'publicData', 'reviewsInfo', 'averageRating'], currentListing);
    const totalReviews = pathOr(null, ['attributes', 'publicData', 'reviewsInfo', 'totalReviews'], currentListing);

    return (
      <Page
        title={schemaTitle}
        scrollingDisabled={scrollingDisabled}
        author={authorDisplayName}
        contentType="website"
        description={description}
        facebookImages={facebookImages}
        twitterImages={twitterImages}
        schema={{
          '@context': 'http://schema.org',
          '@type': 'ItemPage',
          description: description,
          name: schemaTitle,
          image: schemaImages,
        }}
      >
        <CriteoProduct currentUser={currentUser} />
        <LayoutSingleColumn className={css.pageRoot}>
          <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
          <LayoutWrapperMain>
            <div>
              <SectionTitle className={css.sectionTitleDesktop} richTitle={richTitle} />
              <SectionActions
                listing={currentListing}
                shareModalOpen={this.state.shareModalOpen}
                onShareModalClose={() => this.setState({ shareModalOpen: false })}
                handleShareClick={handleShareClick}
                isInMyFavorites={isInMyFavorites}
                handleFavoritesClick={handleFavoritesClick}
                rating={rating}
                totalReviews={totalReviews}
                isHostedBySuperHost={isHostedBySuperHost}
                onManageDisableScrolling={onManageDisableScrolling}
              />
              <SectionImages
                title={title}
                listing={currentListing}
                isOwnListing={isOwnListing}
                editParams={{
                  id: listingId.uuid,
                  slug: listingSlug,
                  type: listingType,
                  tab: listingTab,
                }}
                imageCarouselOpen={this.state.imageCarouselOpen}
                onImageCarouselClose={() => this.setState({ imageCarouselOpen: false })}
                handleViewPhotosClick={handleViewPhotosClick}
                onManageDisableScrolling={onManageDisableScrolling}
              />
              <SectionTitle className={css.sectionTitleMobile} richTitle={richTitle} />
              <div className={css.contentContainer}>
                <div className={css.mainContent}>
                  <SectionHeading
                    priceTitle={priceTitle}
                    formattedPrice={formattedPrice}
                    richTitle={richTitle}
                    minCapacity={minCapacity}
                    maxCapacity={maxCapacityToGuest}
                    user={currentAuthor}
                    params={params}
                    listing={currentListing}
                  />
                  <SectionDescription
                    description={description}
                    providerPresentConfig={providerPresentConfig}
                    securityConfig={securityConfig}
                    publicData={publicData}
                  />
                  <SectionFeaturesMaybe options={amenitiesConfig} publicData={publicData} />
                  <SectionRulesMaybe className={css.sectionRules} publicData={publicData} />
                  <SectionSessionTimes publicData={publicData}/>
                </div>
                <BookingPanel
                  className={css.bookingPanel}
                  listing={currentListing}
                  isOwnListing={isOwnListing}
                  unitType={unitType}
                  onSubmit={handleBookingSubmit}
                  authorDisplayName={authorDisplayName}
                  onManageDisableScrolling={onManageDisableScrolling}
                  timeSlots={timeSlots}
                  fetchTimeSlotsError={fetchTimeSlotsError}
                  maxCapacityToGuest={maxCapacityToGuest}
                  minCapacityToGuest={minCapacity}
                  suitableForChildren={suitableForChildren}
                  showContactUser={showContactUser}
                  onContactUser={this.onContactUser}
                  onSubmitEnquiry={this.onSubmitEnquiry}
                />
                <Modal
                  id="ListingPage.enquiry"
                  contentClassName={css.enquiryModalContent}
                  isOpen={isAuthenticated && this.state.enquiryModalOpen}
                  onClose={() => this.setState({ enquiryModalOpen: false })}
                  usePortal
                  onManageDisableScrolling={onManageDisableScrolling}
                >
                  <EnquiryForm
                    className={css.enquiryForm}
                    submitButtonWrapperClassName={css.enquirySubmitButtonWrapper}
                    listingTitle={title}
                    authorDisplayName={authorDisplayName}
                    sendEnquiryError={sendEnquiryError}
                    onSubmit={this.handleSubmitEnquiryWithPartialData}
                    inProgress={sendEnquiryInProgress}
                  />
                </Modal>
                <ProfileCompletionModal
                  id="ProfileCompletionModal"
                  isOpen={this.state.isProfileCompletionModalOpen}
                  onCloseModal={this.handleToogleProfileCompletionModal}
                  onManageDisableScrolling={onManageDisableScrolling}
                  onOkModal={this.handleOkBookingModal}
                />
              </div>
              <div className={css.secondaryContentContainer}>
                <SectionReviews rating={rating} reviews={reviews} fetchReviewsError={fetchReviewsError} />
                <SectionHostMaybe listing={currentListing} currentUser={currentUser} />
                {similarListings.length > 0 ? (
                  <SectionSimilarListings
                    listings={similarListings}
                    searchInProgress={searchInProgress}
                    searchListingsError={searchListingsError}
                  />
                ) : null}
              </div>
            </div>
          </LayoutWrapperMain>
          <LayoutWrapperFooter>
            <Footer />
          </LayoutWrapperFooter>
        </LayoutSingleColumn>
      </Page>
    );
  }
}

ListingPageComponent.defaultProps = {
  unitType: config.bookingUnitType,
  currentUser: null,
  enquiryModalOpenForListingId: null,
  showListingError: null,
  reviews: [],
  fetchReviewsError: null,
  timeSlots: null,
  fetchTimeSlotsError: null,
  sendEnquiryError: null,
  amenitiesConfig: config.custom.amenities,
  providerPresentConfig: config.custom.providerPresentOptions,
  securityConfig: config.custom.securityOptions,
  filterConfig: config.custom.filters,
  similarListings: [],
  searchListingsError: null,
};

ListingPageComponent.propTypes = {
  // from withRouter
  history: shape({
    push: func.isRequired,
  }).isRequired,
  location: shape({
    search: string,
  }).isRequired,

  unitType: propTypes.bookingUnitType,
  // from injectIntl
  intl: intlShape.isRequired,

  params: shape({
    id: string.isRequired,
    slug: string,
    variant: oneOf([LISTING_PAGE_PENDING_APPROVAL_VARIANT]),
  }).isRequired,

  isAuthenticated: bool.isRequired,
  currentUser: propTypes.currentUser,
  getListing: func.isRequired,
  getOwnListing: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  scrollingDisabled: bool.isRequired,
  enquiryModalOpenForListingId: string,
  showListingError: propTypes.error,
  callSetInitialValues: func.isRequired,
  reviews: arrayOf(propTypes.review),
  fetchReviewsError: propTypes.error,
  timeSlots: arrayOf(propTypes.timeSlot),
  fetchTimeSlotsError: propTypes.error,
  sendEnquiryInProgress: bool.isRequired,
  sendEnquiryError: propTypes.error,
  onSendEnquiry: func.isRequired,
  amenitiesConfig: array,
  providerPresentConfig: array,
  securityConfig: array,
  onInitializeCardPaymentData: func.isRequired,
  filterConfig: array,
  similarListings: array,
  searchInProgress: bool.isRequired,
  searchListingsError: propTypes.error,
};

const mapStateToProps = (state, props) => {
  const { isAuthenticated } = state.Auth;
  const {
    showListingError,
    reviews,
    fetchReviewsError,
    timeSlots,
    fetchTimeSlotsError,
    sendEnquiryInProgress,
    sendEnquiryError,
    enquiryModalOpenForListingId,
  } = state.ListingPage;
  const { currentUser } = state.user;
  const { searchParams } = state.SearchPage;
  const { similarListingIds, searchInProgress, searchListingsError } = state.SearchPage;

  const similarListingsRefs = map(listingId => ({ id: listingId, type: 'listing' }), similarListingIds);
  const similarListings = getMarketplaceEntities(state, similarListingsRefs);

  const myFavorites =
    pathOr([], ['attributes', 'profile', 'protectedData', 'myFavorites'], currentUser);
  const { params } = props;
  const listingId = new UUID(params.id);
  const isInMyFavorites = includes(listingId.uuid, myFavorites);
  const getListing = id => {
    const ref = { id, type: 'listing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  const getOwnListing = id => {
    const ref = { id, type: 'ownListing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  return {
    isAuthenticated,
    currentUser,
    getListing,
    getOwnListing,
    scrollingDisabled: isScrollingDisabled(state),
    enquiryModalOpenForListingId,
    showListingError,
    reviews,
    fetchReviewsError,
    timeSlots,
    fetchTimeSlotsError,
    sendEnquiryInProgress,
    sendEnquiryError,
    isInMyFavorites,
    searchParams,
    similarListings,
    searchInProgress,
    searchListingsError,
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  callSetInitialValues: (setInitialValues, values, saveToSessionStorage) =>
    dispatch(setInitialValues(values, saveToSessionStorage)),
  onSendEnquiry: (listingId, bookingDate, bookingStart, isBookingFullDay, participants, message, fromSearch) =>
    dispatch(sendEnquiry(listingId, bookingDate, bookingStart, isBookingFullDay, participants, message, fromSearch)),
  onInitializeCardPaymentData: () => dispatch(initializeCardPaymentData()),
  onUpdateCurrentProfile: (data) => dispatch(updateProfile(data)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const ListingPage = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(ListingPageComponent);

ListingPage.setInitialValues = initialValues => setInitialValues(initialValues);
ListingPage.loadData = loadData;

export default ListingPage;



// WEBPACK FOOTER //
// ./src/containers/ListingPage/ListingPage.js